import styled from 'styled-components';

export const StyledSearch = styled.div`
  flex-direction: row;
  flex-grow: 1;
  min-width: 0;

  .flex-grow {
    flex-grow: 2;
    display: flex;
  }

  .ant-form-item {
    margin: 0;
    display: flex;
    flex-grow: 1;

    .ant-form-item-row {
      display: flex;
      flex-grow: 1;
    }

    .ant-row {
      display: flex;
      flex-grow: 1;
    }
  }

  .ant-input-outlined {
    border-color: ${(props) => props.theme.brand01};
  }

  .input-container {
    flex-grow: 1;
  }
`;
